module.exports = __webpack_public_path__ + "img/school.794ab4a8.png";